/**
 * Sanitizes and validates a URL to prevent XSS (e.g. javascript: protocols).
 * Only allows http:// and https:// URLs.
 *
 * @param {string} url - The URL to sanitize.
 * @returns {string|null} - The validated, trimmed URL or null if invalid/unsafe.
 */
export const sanitizeUrl = (url) => {
  if (!url) return null;
  const trimmed = url.trim();
  const lower = trimmed.toLowerCase();
  if (lower.startsWith('http://') || lower.startsWith('https://')) {
    return trimmed;
  }
  return null;
};
